import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { TrendingUp, TrendingDown, Target, DollarSign, Users, Percent } from 'lucide-react';
interface KPIMetric {
  title: string;
  target: number;
  actual: number;
  unit: string;
  icon: any;
}
export function KPITracker() {
  const [metrics] = useState<KPIMetric[]>([{
    title: 'Monatlicher Umsatz',
    target: 50000,
    actual: 45000,
    unit: '€',
    icon: DollarSign
  }, {
    title: 'Quartalsumsatz',
    target: 150000,
    actual: 135000,
    unit: '€',
    icon: DollarSign
  }, {
    title: 'Verkaufsgespräche',
    target: 50,
    actual: 48,
    unit: '',
    icon: Users
  }, {
    title: 'Neue Leads',
    target: 100,
    actual: 95,
    unit: '',
    icon: Target
  }, {
    title: 'Lead-zu-Opportunity',
    target: 30,
    actual: 28,
    unit: '%',
    icon: Percent
  }, {
    title: 'Opportunity-zu-Abschluss',
    target: 25,
    actual: 22,
    unit: '%',
    icon: Percent
  }]);
  const calculateDeviation = (target: number, actual: number) => {
    const deviation = (actual - target) / target * 100;
    return deviation.toFixed(1);
  };
  const isPositive = (target: number, actual: number) => actual >= target;
  return <div className="p-6 space-y-6" data-id="element-281">
      <div data-id="element-282">
        <h1 className="text-3xl font-bold text-foreground" data-id="element-283">KPI Tracker</h1>
        <p className="text-muted-foreground mt-1" data-id="element-284">
          Wichtige Vertriebskennzahlen im Überblick
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-285">
        {metrics.map((metric, index) => {
        const deviation = calculateDeviation(metric.target, metric.actual);
        const positive = isPositive(metric.target, metric.actual);
        const Icon = metric.icon;
        return <Card key={index} data-id="element-286">
              <CardHeader data-id="element-287">
                <div className="flex items-start justify-between" data-id="element-288">
                  <div className="flex-1" data-id="element-289">
                    <CardTitle className="text-base" data-id="element-290">{metric.title}</CardTitle>
                  </div>
                  <div className="h-10 w-10 rounded-lg bg-[#f88d3e]/10 flex items-center justify-center" data-id="element-291">
                    <Icon className="h-5 w-5 text-[#f88d3e]" data-id="element-292" />
                  </div>
                </div>
              </CardHeader>
              <CardContent className="space-y-3" data-id="element-293">
                <div className="space-y-2" data-id="element-294">
                  <div className="flex items-center justify-between text-sm" data-id="element-295">
                    <span className="text-muted-foreground" data-id="element-296">Ziel:</span>
                    <span className="font-medium" data-id="element-297">
                      {metric.target.toLocaleString()}
                      {metric.unit}
                    </span>
                  </div>
                  <div className="flex items-center justify-between text-sm" data-id="element-298">
                    <span className="text-muted-foreground" data-id="element-299">Ist:</span>
                    <span className="font-medium" data-id="element-300">
                      {metric.actual.toLocaleString()}
                      {metric.unit}
                    </span>
                  </div>
                  <div className="flex items-center justify-between text-sm" data-id="element-301">
                    <span className="text-muted-foreground" data-id="element-302">Abweichung:</span>
                    <span className={`font-medium flex items-center gap-1 ${positive ? 'text-green-600' : 'text-red-600'}`} data-id="element-303">
                      {positive ? <TrendingUp className="h-4 w-4" data-id="element-304" /> : <TrendingDown className="h-4 w-4" data-id="element-305" />}
                      {deviation}%
                    </span>
                  </div>
                </div>
                <div className="w-full bg-muted rounded-full h-2" data-id="element-306">
                  <div className={`h-2 rounded-full ${positive ? 'bg-green-500' : 'bg-[#f88d3e]'}`} style={{
                width: `${Math.min(metric.actual / metric.target * 100, 100)}%`
              }} data-id="element-307" />
                </div>
              </CardContent>
            </Card>;
      })}
      </div>

      <Card data-id="element-308">
        <CardHeader data-id="element-309">
          <CardTitle data-id="element-310">Kundenkennzahlen</CardTitle>
          <CardDescription data-id="element-311">
            Durchschnittliche Werte und Bindungsraten
          </CardDescription>
        </CardHeader>
        <CardContent data-id="element-312">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-313">
            <div className="space-y-2" data-id="element-314">
              <label className="text-sm font-medium" data-id="element-315">
                Durchschnittliche Abschlussgröße
              </label>
              <div className="space-y-2" data-id="element-316">
                <div className="flex items-center gap-2" data-id="element-317">
                  <span className="text-xs text-muted-foreground w-12" data-id="element-318">
                    Ziel:
                  </span>
                  <Input type="number" placeholder="5000" className="flex-1" data-id="element-319" />
                  <span className="text-sm" data-id="element-320">€</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-321">
                  <span className="text-xs text-muted-foreground w-12" data-id="element-322">
                    Ist:
                  </span>
                  <Input type="number" placeholder="4500" className="flex-1" data-id="element-323" />
                  <span className="text-sm" data-id="element-324">€</span>
                </div>
              </div>
            </div>
            <div className="space-y-2" data-id="element-325">
              <label className="text-sm font-medium" data-id="element-326">Kundenbindungsrate</label>
              <div className="space-y-2" data-id="element-327">
                <div className="flex items-center gap-2" data-id="element-328">
                  <span className="text-xs text-muted-foreground w-12" data-id="element-329">
                    Ziel:
                  </span>
                  <Input type="number" placeholder="85" className="flex-1" data-id="element-330" />
                  <span className="text-sm" data-id="element-331">%</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-332">
                  <span className="text-xs text-muted-foreground w-12" data-id="element-333">
                    Ist:
                  </span>
                  <Input type="number" placeholder="82" className="flex-1" data-id="element-334" />
                  <span className="text-sm" data-id="element-335">%</span>
                </div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      <div className="p-4 rounded-lg bg-[#f88d3e]/10 border border-[#f88d3e]/20" data-id="element-336">
        <p className="text-sm text-muted-foreground" data-id="element-337">
          💡 <strong data-id="element-338">Tipp:</strong> Aktualisieren Sie diese Übersicht monatlich,
          um die Vertriebsleistung zu überwachen und Verbesserungspotenziale zu
          identifizieren.
        </p>
      </div>
    </div>;
}